import type { TableHead } from '@/types/table/table-head'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getCellTextStyle(head: TableHead, value: any) {
  return head.getCustomStyle ? head.getCustomStyle(value) : ''
}
